import querystring from 'query-string';
import { i18n }  from '@/locales/index';
import sensors from 'sa-sdk-javascript';
import appConfig from './app';

// App与国家、区号、以及号码相关正则
export const AppList = appConfig

// 多语言函数
export const $t = i18n

export function checkPhone(str = '') {
  let s = str.toString().replace(/ /g, ''); // 清空空格 手动清空
  return /^\d{10}$/.test(s); // 10位数字
}

export function formatPhone(str='') {
  if( checkPhone(str) ) {
    return str.substring(0, 2) + ' ' + str.substring(2, 4) + ' ' + str.substring(4, 8);
  }
  return str;
}

// 当前地理位置经纬度
export function getLocation() {
  return new Promise((res, rej)=>{
    if ( navigator.geolocation ) {
      navigator.geolocation.getCurrentPosition(pos=>{
        let { latitude, longitude } = pos.coords;

        res({
          latitude, longitude
        })
      })
    } else {
      rej({
        latitude: '',
        longitude: '',
      })
    }
  })
}

// 当前url下的get参数
export function getQueryVariable (variable){
  const query = querystring.parse(window.location.search)
  const varKey = variable.toLowerCase(); // 全都转小写比较 兼容大小写不区分的url

  for(let key in query) {
    if (key.toLowerCase() === varKey) {
      // if(/^[0-9]/.test(query[key])) { // 如果是数字开头,那么就在前面上下划线
      //   return '_' + query[key]
      // } else {
      // }
      return query[key]
    }
  }

  return false;
}

export function getArray2Name (arrs, name) {
  return arrs.find(items => {
    return items.name === name;
  }) || false
}

// 异步load js
export function asyncLoadJs (url) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.onload = ()=>{
      resolve();
    }
    script.onerror = ()=>{
      reject();
    }
    script.src= url;
    document.getElementsByTagName('body')[0].appendChild(script);
  })
}

// 神策打点 - 初始化相关
export function sensorsMonitor(config = {}) {
  const isDev = process.env.NODE_ENV === 'development';
  sensors.init({
    server_url: isDev ?
      'https://salasa.xcreditech.com/sa' :
      'https://salasa.xcreditech.com/sa?project=production',
    heatmap: {
      // 是否开启点击图，default 表示开启，
      // 自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达注意力图，not_collect 表示关闭，
      // 不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      track_attr: ['data-sa', 'data-sensors'], // 全埋点自定义属性
    },
    is_track_single_page: true, // 是否单页面
    show_log: false, //isDev,
    app_js_bridge: true,
    batch_send: true,
    is_track_device_id: true, // 收集神策is_track_device_id
  });

  sensors.registerPage({
    current_url: window.location.href,
  })
  sensors.quick('autoTrack');
  return sensors;
}
// ant-mobile的兼容
function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}
export function onWrapTouchStart(e) {
  // fix touch to scroll background page on iOS
  if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    return;
  }
  const pNode = closest(e.target, '.am-modal-content');
  if (!pNode) {
    e.preventDefault();
  }
}

// 格式化数字 千分位
export function format3Number(count = 0) {
  if (!+count) {
    return '0.00';
  }

  return (+count).toFixed(2).toLocaleString('en-US');
}

// 修改icon
export function changeIco(app) {
  let link = document.createElement('link');
  let oldLink = document.getElementById('AppIco');

  link.id = 'AppIco';
  link.rel = 'shortcut icon';
  link.href = `${ window.$localCdnLink }/icon/${ app }.webp`;
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
}

// 判断ios
function isIos () {
  // 浏览器的用户代理报头
  const ua = navigator.userAgent;
  return /(iPhone|iPad|iPod|iOS)/i.test(ua);
}
// 打开下载app页面
function openDownloadApp (url) {
  const h = document.hidden || document.mozHidden || document.msHidden || document.webkitHidden;
  if (typeof h === 'undefined' || h === false) {
    // 延迟10s 以保证页面已跳转过去or已经启动对应app
    setTimeout(() => {
      window.open(url, '_blank');
    }, 10000)
  }
}

// 打开短信
export function sendSms(phone = '', sms = '') {
  // 短信内容需要转码
  const body = encodeURIComponent(sms)
  let link = '';
  if (isIos() ) { // ios系统
    link = `sms:${phone}&body=${body}`;
  } else {
    link = `sms:${phone}?body=${body}`;
  }

  window.location.href = link;
}

// 打开邮箱
export function sendMail(mail = '', body = '') {
  window.location.href = `mailto:${ mail }?body=${ encodeURIComponent(body) }`;
}

/**
 * 打开WhatsApp app
 * @phone 发送内容
 * @body 号码
 * @notOpenDownload 是否打开下载app链接、默认(false)打开
 */
export function openWhatsapp(phone = '', body = '', notOpenDownload = false) {
  window.location.href = `https://wa.me/${ phone}?text=${ encodeURIComponent(body) }`;

  // 防止未触发app 跳转到下载链接
  let link = '';
  if (isIos()) {
    // 先拨打WhatsApp 然后跳转到下载app
    link = "https://apps.apple.com/us/app/whatsapp-messenger/id310633997";
  } else { // Android
    link = "https://play.google.com/store/apps/details?id=com.whatsapp";
  }
  
  !notOpenDownload && openDownloadApp(link)
}

// 打开Messenger
export function openMessenger(url = '', notOpenDownload = false) {
  // 有些手机没有安装messenger
  window.location.href = 'fb-messenger://share?link=' + encodeURIComponent(url);

  // 防止未触发app 跳转到下载链接
  let link = '';
  if (isIos()) {
    // 先拨打WhatsApp 然后跳转到下载app
    link = "https://itunes.apple.com/us/app/whatsapp-messenger/id310633997?mt=8";
  } else { // Android
    link = 'https://play.google.com/store/apps/details?id=com.facebook.orca';
  }
  !notOpenDownload && openDownloadApp(link)
}

export function openTwitter(url = '', text = '', notOpenDownload = false) {
  window.location.href = `https://twitter.com/intent/tweet?url=${ encodeURIComponent(url) }&text=${ encodeURIComponent(text) }`;

  // 防止未触发app 跳转到下载链接
  let link = '';
  if (isIos()) {
    // 先拨打WhatsApp 然后跳转到下载app
    link = "https://apps.apple.com/us/app/twitter/id333903271";
  } else { // Android
    link = 'https://play.google.com/store/apps/details?id=com.twitter.android';
  }
  !notOpenDownload && openDownloadApp(link)
}

export function openInstagram(notOpenDownload) {
  window.location.href = `https://www.instagram.com/aiaindonesia/`;

  // 防止未触发app 跳转到下载链接
  let link = '';
  if (isIos()) {
    // 先拨打WhatsApp 然后跳转到下载app
    link = "https://apps.apple.com/app/instagram/id389801252?vt=lo";
  } else { // Android
    link = 'https://play.google.com/store/apps/details?id=com.instagram.android';
  }
  !notOpenDownload && openDownloadApp(link)
}

// 复制内容到剪切板
export function copyToClip(content) {
  const aux = document.createElement("input");
  aux.setAttribute("value", content);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
}

// 获取白屏时间
export const getWhiteTime = () => {
  const t = window.performance.timing;
  // 记录白屏时间 ms
  return (t.domInteractive || t.domLoading) - t.fetchStart
}

export const setAliasApp = (app = '') => {
  if (!app) return ''

  const local = (app || '').toLowerCase()
  const alias = {
    'tifi.ke': 'tifi-ke',
    'ke.tifi': 'tifi-ke',
    'champ-loan': 'champloan',
    'champ_loan': 'champloan',
    'champ': 'champloan',
    'xcredito': 'icredito',
    '9jacash': '_9jacash',
  }

  return alias[local] || local;
}

// 目前工资贷tifi仅有一个app 无需做区分，故baseURL为/
// 小贷很多app需要区分 添加baseURL为/{ app }
export const getProxyConfig = (app = '') => {
  if (app === 'tifislice' || app === 'tifi_slice' || app === 'tifi-slice' || app === 'tifislice_ke') {
    return {
      type: 'tifi_slice',
      baseURL: '/tifi-slice',
    }
  }

  if (app === 'tifi' || app === 'tifi.ke' || app === 'tifi-ke') {
    return {
      type: 'tifi', // 默认是loan 工资贷为tifi
      baseURL: '/',
    }
  }
  if (app === '_9jacash') {
    return {
      type: 'loan', // 默认是loan 工资贷为tifi
      baseURL: process.env.NODE_ENV === 'development' ? `/9jacash` : '/',
    }
  }

  return {
    type: 'loan',
    baseURL: process.env.NODE_ENV === 'development' ? `/${ app }` : '/',
  }
}
